import "@/App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Projects from "./pages/Projects";
import ProjectDetail from "./pages/ProjectDetail";
import Tasks from "./pages/Tasks";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Files from "./pages/Files";
import Credentials from "./pages/Credentials";
import Payments from "./pages/Payments";
import TimeTracking from "./pages/TimeTracking";
import ActivityPage from "./pages/ActivityPage";
import CalendarPage from "./pages/CalendarPage";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-[#11152F]" data-testid="app-loader">
      <img src="/assets/logo-mark.png" alt="" className="h-20 w-20 animate-pulse" />
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/projekte" element={<Projects />} />
            <Route path="/projekte/:id" element={<ProjectDetail />} />
            <Route path="/aufgaben" element={<Tasks />} />
            <Route path="/kunden" element={<Clients />} />
            <Route path="/kunden/:id" element={<ClientDetail />} />
            <Route path="/dateien" element={<Files />} />
            <Route path="/zugaenge" element={<Credentials />} />
            <Route path="/zahlungen" element={<Payments />} />
            <Route path="/zeiterfassung" element={<TimeTracking />} />
            <Route path="/aktivitaet" element={<ActivityPage />} />
            <Route path="/kalender" element={<CalendarPage />} />
            <Route path="/einstellungen" element={<Settings />} />
            <Route path="/profil" element={<Profile />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
